import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import {
  StyledDesc,
  StyledLink,
  StyledProducImgBox,
  StyledSchemeDesc,
  StyledProductButton,
  StyledSchemeBox,
  StyledSchemeLine,
  StyledProductImage,
  StyledProductLayer,
  SchemeLinkButton,
} from './Scheme.style';

import access from '@src/lang/ko/main/access/access';
import { StyledGridColumn, StyledGridContainer, StyledGridRow } from '@components/Grid/Grid.style';
import { IconCheck, IconCheckBlack, IconCheckBold, IconSearch } from '@assets/images/icon';
import { HeadingColor, ImgWH, LabelColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DivAllCenter, DivJustify, FontPage } from '@pages/CommonStyle/commonDiv.style';

import accessScheme from '@src/lang/ko/main/access/productScheme';
import cameraScheme from '@src/lang/ko/main/camera/productScheme';
import rtlsScheme from '@src/lang/ko/main/rtls/productScheme';
import outdoorScheme from '@src/lang/ko/main/outdoor/productScheme';
import iotScheme from '@src/lang/ko/main/iot/productScheme';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { LabelH3 } from '@components/Text/Label/Label.style';
import { Link } from 'react-router-dom';
import { ShowLabel } from '@pages/Main/Home/components/Solution/Solution.style';
import i18n from '@pages/i18n';

const Scheme = ({ handleIconClickLocal, product }): React.ReactElement => {
  const [productName, setProductName] = useState<string>('');
  const [path, setPath] = useState<string>('');
  const [dataSheet, setDataSheet] = useState<any>({}); // Provide an initial value, an empty object in this case
  const [products, setProducts] = useState<any>([]);
  const [a, setA] = useState<any>([]);
  const [b, setB] = useState<any>([]);
  const [c, setC] = useState<any>([]);
  const [d, setD] = useState<any>([]);
  const [e, setE] = useState<any>([]);

  useEffect(() => {
    if (product === 'rtls') {
      setProductName('rtls');
      setPath('productSchemeRTLS');
      setDataSheet(rtlsScheme);
    } else if (product === 'camera') {
      setProductName('camera');
      setPath('productSchemeCamera');
      setDataSheet(cameraScheme);
    } else if (product === 'access') {
      setProductName('accessMain');
      setPath('productSchemeAccess');
      setDataSheet(accessScheme);
    } else if (product === 'outdoor') {
      setProductName('outdoor');
      setPath('productSchemeOutdoor');
      setDataSheet(outdoorScheme);
    } else if (product === 'sensor') {
      setProductName('sensor');
      setPath('productSchemeSensor');
      setDataSheet(iotScheme);
    }

    // dataSheet가 유효한 경우에만 setProducts 등을 호출
    if (dataSheet && dataSheet.spec) {
      setProducts(dataSheet.spec);
      setA(dataSheet.a || []); // 초기값을 빈 배열로 설정
      setB(dataSheet.b || []); // 초기값을 빈 배열로 설정
      setC(dataSheet.c || []); // 초기값을 빈 배열로 설정
      setD(dataSheet.d || []); // 초기값을 빈 배열로 설정
      setE(dataSheet.e || []); // 초기값을 빈 배열로 설정
    }
  }, [product, dataSheet]);

  return (
    <>
      <Spacing pixel="128" />
      <StyledGridContainer>
        <StyledGridRow>
          <StyledGridColumn desktop={12} tablet={8} mobile={4}>
            <DivAllCenter>
              <DisplayH2 size={'small'}>
                <Trans i18nKey={`${productName}.banner.schemeTitle`} />
              </DisplayH2>
            </DivAllCenter>
            {/* <StyledDesc size={'medium'}>
              <p>
                <Trans i18nKey={`${productName}.banner.schemeDesc`} />
                <StyledLink size={'medium'} inline>
                  <Trans i18nKey={access.banner.phone} />
                </StyledLink>
                <Trans i18nKey={`${productName}.banner.schemeDesc2`} />
              </p>
            </StyledDesc> */}
          </StyledGridColumn>
        </StyledGridRow>

        <Spacing pixel="48" />

        {/* 이미지, 버튼 출력 */}
        <StyledProductLayer>
          {products.map((product, index) => (
            <>
              <StyledProducImgBox>
                {product.image && (
                  <>
                    <StyledProductImage src={product.image} alt="RTLS Product" />
                    <Spacing pixel="8" />
                    <HeadingColor color="#2A70F0" size="xxxsmall">
                      <Trans i18nKey={`${path}.spec.${index}.title`} />
                    </HeadingColor>
                    {/* <Spacing pixel="4" />

                    <LabelColor color="#bdbdd" size="small">
                      <Trans i18nKey={product.desc} />
                    </LabelColor> */}
                    {/* <Spacing pixel="16" /> */}
                  </>
                )}
              </StyledProducImgBox>
            </>
          ))}
        </StyledProductLayer>

        <Spacing pixel="16" />
        {Array.from({ length: dataSheet?.a?.length }).map((_, idx, arr) => (
          <div key={`product-${idx}`}>
            <>
              <StyledSchemeLine isLast={idx === arr.length - 1}>
                <StyledSchemeBox>
                  <ShowLabel>
                    <ImgWH w="16" h="16" src={dataSheet?.a?.[idx]?.icon} />
                    <Spacing pixel="10" />
                    <LabelH3 size={'medium'}>
                      <Trans i18nKey={`${path}.a.${idx}.text`} />
                    </LabelH3>
                  </ShowLabel>
                </StyledSchemeBox>

                <StyledSchemeBox center={true}>
                  {b[idx]?.text === '1' ? (
                    <DivJustify>
                      <ImgWH w="20" h="20" src={IconCheckBold} alt="Check Icon" />
                    </DivJustify>
                  ) : (
                    <StyledSchemeDesc size={'medium'}>
                      <p>
                        <Trans i18nKey={`${path}.b.${idx}.text`} />
                      </p>
                    </StyledSchemeDesc>
                  )}
                </StyledSchemeBox>

                <StyledSchemeBox center={true}>
                  {c[idx]?.text === '1' ? (
                    <DivJustify>
                      <ImgWH w="20" h="20" src={IconCheckBold} alt="Check Icon" />
                    </DivJustify>
                  ) : (
                    <StyledSchemeDesc size={'medium'}>
                      <p>
                        <Trans i18nKey={`${path}.c.${idx}.text`} />
                      </p>
                    </StyledSchemeDesc>
                  )}
                </StyledSchemeBox>

                {d.length > 0 && (
                  <StyledSchemeBox center={true}>
                    {d[idx]?.text === '1' ? (
                      <DivJustify>
                        <ImgWH w="20" h="20" src={IconCheckBold} alt="Check Icon" />
                      </DivJustify>
                    ) : (
                      <StyledSchemeDesc size={'medium'}>
                        <p>
                          <Trans i18nKey={`${path}.d.${idx}.text`} />
                        </p>
                      </StyledSchemeDesc>
                    )}
                  </StyledSchemeBox>
                )}

                {e.length > 0 && (
                  <StyledSchemeBox center={true}>
                    {e[idx]?.text === '1' ? (
                      <DivJustify>
                        <ImgWH w="20" h="20" src={IconCheckBold} alt="Check Icon" />
                      </DivJustify>
                    ) : (
                      <StyledSchemeDesc size={'medium'}>
                        <p>
                          <Trans i18nKey={`${path}.e.${idx}.text`} />
                        </p>
                      </StyledSchemeDesc>
                    )}
                  </StyledSchemeBox>
                )}
              </StyledSchemeLine>
            </>
          </div>
        ))}

        <>
          {/* 이미지, 버튼 출력 */}
          <StyledProductLayer>
            {products.map((product, index) => (
              <>
                <SchemeLinkButton>
                  {product.image && (
                    <>
                      <Link to={i18n.language === 'ko' ? product.link : `/${i18n.language}${product.link}`}>
                        <StyledProductButton>
                          <Trans i18nKey={'home.showMore'} />
                        </StyledProductButton>
                      </Link>
                    </>
                  )}
                </SchemeLinkButton>
              </>
            ))}
          </StyledProductLayer>
        </>
      </StyledGridContainer>
      <SpacingDTM d="64" t="64" m="32" />
    </>
  );
};

export default Scheme;
